// Page d'un module NON SOUSCRIT : ce qu'il fait, et comment l'obtenir.
//
// UN RENVERSEMENT ASSUMÉ DE LA RÈGLE DU PROJET
//
// Jusqu'ici, un module non souscrit était MASQUÉ, au motif qu'« un bouton qui
// répond 403 donne l'impression d'un logiciel cassé plutôt que d'une option
// non prise ». C'était juste tant que l'intention était de ne pas égarer
// l'utilisateur.
//
// L'intention est maintenant COMMERCIALE : un client ne demande pas ce qu'il
// ne sait pas exister. On montre donc les modules, grisés, avec ce qu'ils
// apportent — décision de Yanis, 12/08/2026.
//
// CE QUI REND LE RENVERSEMENT TENABLE, ET QU'IL NE FAUT PAS DÉFAIRE :
//
//   1. cette page est STATIQUE. Elle n'appelle AUCUNE route du module. Un
//      écran verrouillé qui interrogerait quand même le serveur afficherait
//      une erreur au lieu d'une offre — exactement ce que la règle d'origine
//      voulait éviter ;
//   2. `exiger_module` continue de refuser côté serveur. Le grisé n'a jamais
//      été la protection, et il ne le devient pas : l'adresse se tape.
import { useState } from "react";
import { Link, useParams } from "react-router-dom";

import Layout from "../components/Layout";
import NousContacter from "../components/NousContacter";

// Le texte est ici, en clair, et pas dans la base : c'est un argumentaire, il
// change au rythme du produit et non à celui d'un client.
export const MODULES = {
  inspections: {
    titre: "Inspections",
    drapeau: "module_vgp",
    resume:
      "Les VGP de hayon et les contrôles techniques, préparés dans " +
      "l'application et rendus en PDF conformes aux fiches d'origine.",
    apports: [
      "Un rapport PDF prêt à présenter, avec vos photos de défauts",
      "Les échéances de VGP suivies véhicule par véhicule",
      "L'historique complet des contrôles, sans classeur papier",
    ],
  },
  stock: {
    titre: "Stock",
    drapeau: "module_stock",
    resume:
      "Le magasin de l'atelier : plaquettes, filtres, huile. Ce que vous " +
      "avez, ce qui sort, et ce qui va manquer.",
    apports: [
      "Les pièces consommées déduites automatiquement d'une intervention",
      "Un seuil par article, pour commander avant la rupture",
      "Chaque mouvement tracé : plus d'écart inexplicable à l'inventaire",
    ],
  },
  financement: {
    titre: "Financement",
    drapeau: "module_financement",
    resume:
      "Crédit-bail, LOA, crédit ou fonds propres : ce que votre parc vous " +
      "coûte encore, et ce qui se termine bientôt.",
    apports: [
      "L'encours estimé de toute la flotte, en un chiffre",
      "Une alerte 90 jours avant la fin d'un contrat, le temps de décider",
      "Deux exports : Excel pour le comptable, PDF daté pour la banque",
    ],
  },
  location: {
    titre: "Locations",
    drapeau: "module_location",
    resume:
      "Un camion loué à un tiers : le contrat signé à l'écran, l'état des " +
      "lieux en photos, et ce que la location vous rapporte vraiment.",
    apports: [
      "Contrat, retour et avenants en PDF, signés au doigt sur téléphone",
      "Les locations en cours d'un coup d'œil, avec le temps restant",
      "Une alerte avant la fin, pour ne pas laisser un camion rendu en retard",
    ],
  },
};

export default function PresentationModule({ user, onLogout }) {
  const { nom } = useParams();
  const module = MODULES[nom];
  const [contact, setContact] = useState(false);

  if (!module) {
    return (
      <Layout user={user} onLogout={onLogout}>
        <div className="entete-page">
          <h2>Module inconnu</h2>
        </div>
        <p className="vide">
          Ce module n’existe pas. <Link to="/">Retour au tableau de bord</Link>
        </p>
      </Layout>
    );
  }

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="entete-page">
        <h2>{module.titre}</h2>
      </div>

      <section className="carte">
        <p className="sous-info">
          <strong>Ce module n’est pas activé sur votre compte.</strong>
        </p>
        <p>{module.resume}</p>

        <ul className="liste-apports">
          {module.apports.map((a) => (
            <li key={a}>{a}</li>
          ))}
        </ul>

        {/* Pas de bouton d'ACTIVATION : un client ne s'active pas un module
            payant tout seul. Mais dire « contactez Ridelle » sans donner le
            moyen de le faire laissait la phrase sans suite — c'est ce bouton
            qui manquait. */}
        <p className="sous-info">
          Pour l’activer, contactez <strong>Ridelle</strong>. L’activation est
          immédiate et vos données existantes sont conservées.
        </p>
        <div className="modal-actions" style={{ justifyContent: "flex-start" }}>
          <button className="btn-accent" onClick={() => setContact(true)}>
            Demander l’activation
          </button>
        </div>
      </section>

      {contact && (
        <NousContacter module={nom} onFermer={() => setContact(false)} />
      )}
    </Layout>
  );
}
